import React from 'react';

const Clear = (props) => {
  const classes = ['_Clear'];
  if (props.className) {
    classes.push('clear-' + props.className);
  }
  return <div className={classes.join(' ')}/>;
};

export default React.memo(Clear);
